import { render, staticRenderFns } from "./BadgeColumn.vue?vue&type=template&id=6106891f&scoped=true&"
import script from "./BadgeColumn.vue?vue&type=script&lang=js&"
export * from "./BadgeColumn.vue?vue&type=script&lang=js&"
import style0 from "./BadgeColumn.vue?vue&type=style&index=0&id=6106891f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6106891f",
  null
  
)

component.options.__file = "BadgeColumn.vue"
export default component.exports